import styled from 'styled-components'

const StyledDiv = styled.div`
  background-color: #f5f5f5;
  border-radius: 100px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 1rem;
  position: relative;
  width: 100%;
`

interface WrapLineProps {
  backgroundColor: string
  isEnd: number
  isStart: number
  rate: number
}

const StyledLine = styled.div<WrapLineProps>`
  background-color: ${props => props.backgroundColor || '#0000'};
  border-radius: ${({ isEnd, isStart }) =>
    `${isStart ? `100px` : 0} ${isEnd ? `100px 100px` : `0 0`} ${
      isStart ? `100px` : 0
    }`};
  height: 100%;
  width: ${props => props.rate || 0}%;
`

const StyledTitle = styled.div`
  text-align: center;
`

const StyledViolatedText = styled.div`
  background-color: #ffc;
  font-size: smaller;
  font-weight: bold;
  text-align: center;
`

export { StyledDiv, StyledLine, StyledTitle, StyledViolatedText }
